// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"SelectBoxFilter_filterWrapper__1yLxU","filterTitle":"SelectBoxFilter_filterTitle__2n64U","capitalizeTitle":"SelectBoxFilter_capitalizeTitle__3dmJq"};